import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { productionBatchStatistics } from '@reducers/statistics';
import NCFileDetailsModal from './NCFileDetailsModal';
import { getNCFileById, machineEventDetailsWallboard } from '@reducers/manufacture';
import { controlAPICall } from '@helpers';

const NCFileDetailsModalWrapper = ({
  C,
  popupType,
  popupConfig,
  popupWidth,
  clearPopupTimeout,
  triggerHidePopup,
  abortControllerEventStart,
  abortControllerEventEnd,
  abortControllerNcFile,
  getNCFileById,
  productionBatchStatistics,
  machineEventDetailsWallboard,
  batchData,
  ncFileData,
  shouldNotLoadBatch,
  setSelectedNCFile,
}) => {
  const [loading, setLoading] = useState(true);
  const [eventDetails, setEventDetails] = useState({});
  const [NCFileDetails, setNCFileDetails] = useState({});
  const [batchLoading, setBatchLoading] = useState(false);
  const [batch, setBatch] = useState(null);
  const [error, setError] = useState(true);

  useEffect(() => {
    if (ncFileData) {
      setNCFileDetails(ncFileData);
    }
  }, [ncFileData?.ncFileId]);

  useEffect(() => {
    (async () => {
      if (popupConfig.item) {
        setLoading(true);
        setNCFileDetails({});
        const sequenceNumber = popupConfig.item.sequenceNumberStartedOn ?? popupConfig.item.sequenceNumber;

        if (sequenceNumber == null) return;

        const d = { sequenceNumberStartedOn: sequenceNumber, machineId: popupConfig.item.machineId };
        const eventDetails = await controlAPICall(machineEventDetailsWallboard, d, abortControllerEventStart);

        const dEnd = { sequenceNumberStartedOn: popupConfig.item.sequenceNumberEndedOn, machineId: popupConfig.item.machineId };
        let eventDetailsEnd = eventDetails;

        if (popupConfig.item.sequenceNumberEndedOn != null && sequenceNumber !== popupConfig.item.sequenceNumberEndedOn) {
          eventDetailsEnd = await controlAPICall(machineEventDetailsWallboard, dEnd, abortControllerEventEnd);
        }
        if (eventDetails?.[0] && eventDetailsEnd?.[0]) {
          const event = eventDetails[0];
          const eventEnd = eventDetailsEnd[0];
          const durationInSeconds = moment.utc(eventEnd.endedOn).diff(moment.utc(event.startedOn), 'seconds');
          setEventDetails({ ...event, endedOn: eventEnd.endedOn, durationInSeconds });

          if (event && (!ncFileData || ncFileData.ncFileId !== event.ncFileIdMain)) {
            const ncFile = await getNCFileById(event.ncFileIdMain);
            if (ncFile) {
              setNCFileDetails(ncFile);
            }
          }
          setError(false);
          setLoading(false);
          return;
        }
      }
      setLoading(false);
      setError(true);
    })();
    return () => {
      if (abortControllerEventStart.current) {
        abortControllerEventStart.current.abort();
      }
      if (abortControllerEventEnd.current) {
        abortControllerEventEnd.current.abort();
      }
      if (abortControllerNcFile.current) {
        abortControllerNcFile.current.abort();
      }
    };
  }, [popupConfig?.item?.sequenceNumberStartedOn]);

  useEffect(() => {
    if (eventDetails?.productionBatchId == null || shouldNotLoadBatch) return;

    (async () => {
      setBatchLoading(true);
      const batchData = await productionBatchStatistics({ productionBatchId: eventDetails?.productionBatchId });
      if (batchData?.statistics) {
        setBatch(batchData.statistics);
      }
      setBatchLoading(false);
    })();
  }, [eventDetails?.productionBatchId, shouldNotLoadBatch]);

  return (
    <NCFileDetailsModal
      {...{
        batch: batchData || batch,
        batchLoading,
        C,
        clearPopupTimeout,
        error,
        eventDetails,
        loading,
        ncFile: NCFileDetails,
        popupConfig,
        popupType,
        popupWidth,
        triggerHidePopup,
        setSelectedNCFile,
      }}
    />
  );
};

export default connect(null, { productionBatchStatistics, getNCFileById, machineEventDetailsWallboard })(NCFileDetailsModalWrapper);
